import { country } from './../configuration';
import { VehicleTypeName } from './../dossier';

export interface VehicleInformation {
  id?: string;
  createDate?: Date;
  updateDate?: Date;
  countryCode: country;
  licensePlateNumber: string;
  manufacturer: string;
  model: string;
  firstRegistration: Date;
  registrationCode: string;
  version: string;
  characteristics: CarCharacteristics;
  parts: CarPart[];
  vehicleType?: VehicleTypeName;
}

interface CarCharacteristics {
  registration: string;
  registrationType: string;
  color: string;
  energy: string;
  cylinders: number;
  numberOfDoors: number;
  propulsionType: string;
  chassisNumber: string;
  modelYear: number;
  engineNumber: string;
  gearboxType: string;
  gearboxNbSpeed: number;
  gearboxNumber: string;
  unloadedWeight: number;
  horsepower: number;
  fiscalPower: number;
  kwPower: number;
  totalRollingWeight: number;
  co2Emission: number;
}

interface CarPart {
  ProductType: string;
  OEcode: string;
  OEprice: string;
  Currency: string;
  DateTarif: string;
  ArcautoCode: string;
  ADAS: string;
  Sensor: string;
  FittingTime: string;
  TotalTime: string;
  Description: string;
}
